import { createFileRoute, retainSearchParams } from '@tanstack/react-router';

import { TaxonomyStudioLayout } from '~/features/taxonomy-studio/components/layout/taxonomy-studio-layout';
import { taxonomyLayoutSearchSchema } from '~/features/taxonomy-studio/utils/taxonomy-search';
import { requireSystemSubsidiaryAdmin } from '~/utils/guards';

/**
 * Taxonomy Studio — Lily AI platform admins only (super admin in the system
 * subsidiary, the identity SYSTEM_ADMIN rule). `?release=` picks the version every
 * page reads and is retained across the studio's own navigation so a past-version
 * view survives switching pages.
 */
export const Route = createFileRoute('/_authenticated/_tenant/taxonomy')({
  validateSearch: taxonomyLayoutSearchSchema,
  search: { middlewares: [retainSearchParams(['release'])] },
  beforeLoad: requireSystemSubsidiaryAdmin(),
  component: TaxonomyStudioLayout,
});
